import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "7 18 13 12 7 6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 6v12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ChevronLast";
const ChevronLast = memo(themed(Icon));
export {
  ChevronLast
};
//# sourceMappingURL=chevron-last.js.map
